// Register.js (JavaScript) - Version: v1 i5

import { useState } from "react";
import BackButton from "./BackButton";
import "./Login.css"; // Einheitliches Styling für alle Auth-Seiten

export default function Register() {
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const logo = "/logo192.png"; // Logo aus /public/-Ordner laden

    const handleRegister = async (e) => {
        e.preventDefault();
        setMessage("⏳ Link wird gesendet...");

        try {
            const response = await fetch("https://freiseinapp.de/api/register.php", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();
            console.log("📌 API-Antwort:", data);

            if (data.success) {
                setMessage("✅ Ein Link wurde an deine E-Mail gesendet.");
            } else {
                setMessage(data.message || "❌ Fehler bei der Registrierung.");
            }
        } catch (error) {
            console.error("❌ Netzwerkfehler:", error);
            setMessage("❌ Netzwerkfehler. Bitte versuche es später erneut.");
        }
    };

    return (
        <div className="login-container">
            <div className="login-box">
                <img src={logo} alt="FreiSeinApp Logo" className="login-logo" />
                <h2>📝 Neu anmelden</h2>
                <form onSubmit={handleRegister}>
                    <input
                        type="email"
                        placeholder="E-Mail-Adresse"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                    <button type="submit">Registrieren</button>
                </form>
                {message && <p className="login-message">{message}</p>}
                
                <BackButton />
            </div>
        </div>
    );
}
